"use strict";

var __createBinding = void 0 && (void 0).__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = void 0 && (void 0).__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = void 0 && (void 0).__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyTextField = void 0;

const material_1 = require("@mui/material");

const classnames_1 = __importDefault(require("classnames"));

const react_1 = __importStar(require("react"));

const StyledTextField = (0, material_1.styled)(material_1.TextField)({
  [`& .${material_1.inputClasses.input}`]: {
    fontSize: 16
  },
  [`& .${material_1.inputLabelClasses.root}`]: {
    fontSize: 16
  }
});

const SskyTextField = props => {
  let inputProps = {
    onKeyDown: props.onKeyDown,
    maxLength: props.maxLength
  };
  let InputProps = {};

  if (props.startAdornment) {
    InputProps.startAdornment = react_1.default.createElement(material_1.InputAdornment, {
      position: "start"
    }, props.startAdornment);
  }

  if (props.endAdornment) {
    InputProps.endAdornment = react_1.default.createElement(material_1.InputAdornment, {
      position: "end"
    }, props.endAdornment);
  }

  const helperText = (0, react_1.useMemo)(() => {
    var _a, _b;

    if (props.showTextLimit && props.maxLength && typeof props.value === "string") {
      return react_1.default.createElement("span", {
        style: {
          display: "flex"
        }
      }, react_1.default.createElement("span", {
        style: {
          flexGrow: 1
        }
      }, props.helperText), react_1.default.createElement("span", {
        style: {
          whiteSpace: "nowrap",
          marginLeft: "5px"
        }
      }, (_b = (_a = props.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0, " / ", props.maxLength));
    } else {
      return props.helperText;
    }
  }, [props.showTextLimit, props.maxLength, props.value, props.helperText]);
  return react_1.default.createElement(StyledTextField, {
    className: (0, classnames_1.default)(props.className, "uiTextField"),
    id: props.id,
    label: props.label || "",
    value: props.value,
    defaultValue: props.defaultValue,
    placeholder: props.placeholder,
    disabled: props.disabled,
    fullWidth: props.fullWidth,
    required: props.required,
    error: props.error,
    multiline: props.multiline,
    rows: props.rows,
    maxRows: props.rowsMax,
    helperText: helperText,
    type: props.type,
    margin: props.margin,
    onChange: props.onChange,
    onBlur: props.onBlur,
    onFocus: props.onFocus,
    inputProps: inputProps,
    InputProps: InputProps,
    inputRef: props.inputRef,
    autoFocus: props.autoFocus,
    autoComplete: props.autoComplete,
    "data-testid": props.dataTestId || `testId-${props.id || props.label}`,
    "data-tracking-id": props.dataTrackingId || `tracking-id-${props.id || props.label}`,
    variant: props.variant || "standard",
    color: props.color || "primary"
  });
};

exports.SskyTextField = SskyTextField;
SskyTextField.defaultProps = {
  error: false,
  fullWidth: false,
  margin: "none",
  multiline: false,
  type: "text"
};
exports.default = react_1.default.memo(SskyTextField);